<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <a
      class="loyalty-program-list-item-mobile-containing-link"
      [routerLink]="[checkoutUrl()]"
      tabindex="0">
      <span class="loyalty-program-list-item-mobile-container" tabindex="1">
        <div class="loyalty-program-image-container">
          <img
            *ngIf="loyaltyProgramImageUrl()"
            class="loyalty-program-image"
            [src]="loyaltyProgramImageUrl()"
            alt="" />
        </div>
        <span class="transfer-terms">
          <h2 class="loyalty-program-name">{{ loyaltyProgram.name }}</h2>
          <p class="loyalty-base-points">
            {{
              'app.points_with_points_currency'
                | translate: tenantCurrencyPointsParams()
            }}
          </p>
          <rd-shared-icon
            [iconSymbol]="'icon-equal'"
            class="equal-icon"></rd-shared-icon>
          <p class="loyalty-program-equivalent-points">
            {{
              'app.points_with_points_currency'
                | translate: targetCurrencyPointsParams()
            }}
          </p>
        </span>

        <rd-shared-icon
          [iconSymbol]="'icon-chevron-right'"
          class="next-step-arrow"></rd-shared-icon>
      </span>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="loading loading-loyalty-program-list-item-mobile">
      <div class="loading loading-loyalty-program-image"></div>

      <div class="loading-transfer-terms">
        <div class="loading-program-name"></div>
        <div class="loading-loyalty-base-points"></div>
        <div class="loading-loyalty-program-equivalent-points"></div>
      </div>

      <div class="loading loading-next-step-arrow"></div>
    </div>
  </ng-container>
</ng-container>
